import { AxiosInstance, AxiosResponse } from 'axios';
import { QaInterceptorError } from './QaInterceptorError';

export function UseQaInterceptor(instance: AxiosInstance) {
    instance.interceptors.response.use(qaInterceptor);
}

function qaInterceptor(response: AxiosResponse<any>) {
    response.status =
        Number(
            prompt(
                `Input response Status Code for ${response.config.url}`,
                '200'
            )
        ) || response.status;

    if (response.status >= 400) {
        // eslint-disable-next-line no-throw-literal
        throw new QaInterceptorError(response);
    }

    return response;
}
